$(document).ready(function () {
    $("#navToggle").click(function () {
        $('#mainNav').toggleClass('responsive')
        $('#headContainer').toggleClass('h-auto')
    });

    $(window).scroll(function () {
        var scroll = $(this).scrollTop();
        if (scroll > 140) {
            $("#headContainer").addClass("nav-sticky");
        } else {
            $("#headContainer").removeClass("nav-sticky");
        }
    });

    $('.project_carousel').owlCarousel({
        loop: true,
        dots: false,
        lazyLoad: true,
        rtl: _rtl,
        navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>'],
        navClass: ['owl-prev', 'owl-next'],
        mouseDrag: true,
        responsive: {
            0: {
                margin: 10, nav: false, autoWidth: true
            }, 992: {
                margin: 15, items: 3, nav: true,
            }, 1500: {
                margin: 15, items: 4, nav: true,
            }
        }
    });

    $('.resale_carousel').owlCarousel({
        loop: true, dots: false, rtl: _rtl, nav: false, mouseDrag: true, margin: 15, responsive: {
            0: {
                autoWidth: true,
            }, 992: {
                items: 3,
            }, 1500: {
                items: 4,
            }
        }
    });

    $('.testimonials_carousel').owlCarousel({
        loop: true, dots: false, rtl: _rtl, nav: false, mouseDrag: true, margin: 15, autoplay: true, responsive: {
            0: {
                autoWidth: true,
            }, 992: {
                items: 3,
            }, 1500: {
                items: 4,
            }
        }
    });

    $('.ad_carousel').owlCarousel({
        loop: true, dots: false, rtl: _rtl, nav: false, mouseDrag: true, items: 1, autoplay: true,
    });

    if (($(window).width()) < 992) {
        $('.blog-container').addClass('owl-carousel');
        $('.blog-container').owlCarousel({
            loop: true, margin: 10, dots: false, nav: false, rtl: _rtl, center: true, autoWidth: true,
        })

        $('.channel .main-playlist').addClass('owl-carousel');
        $('.channel .main-playlist').owlCarousel({
            loop: true, margin: 10, dots: false, nav: false, rtl: _rtl, center: true, autoWidth: true, autoplay: true,
        })

        $(".headContainer .header .nav .dropdown-toggle").click(function () {
            $(this).siblings().toggleClass('show')
        });
    } else {
        $('.blog-container').trigger('destroy.owl.carousel');
        $('.blog-container').removeClass('owl-carousel');

        $('.channel .main-playlist').trigger('destroy.owl.carousel');
        $('.channel .main-playlist').removeClass('owl-carousel');
    }

    if (window.location.hash == '#ads-modal') {
        loadIntlTelInput(".bitrix24-ads input[type='tel'].b24-form-control")

        if (screen.width > 992) {
            setTimeout(() => $('#ads-modal').modal('show'), 1000);
        } else {
            setTimeout(() => $('#ads-modal').modal('show'), 3000);
        }
    }

    //Buttons do not have an accessible name and owl-dot is a button -- this to improve speed of website
    $(".owl-carousel .owl-dots .owl-dot").attr('aria-label', 'owl-dot');
    $(".owl-carousel .owl-nav .owl-prev").attr('aria-label', 'owl-prev');
    $(".owl-carousel .owl-nav .owl-next").attr('aria-label', 'owl-next');

    $(".numericOnly").keydown(function (event) {
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 || (event.keyCode == 65 && event.ctrlKey === true) || (event.keyCode >= 35 && event.keyCode <= 39)) {
            return;
        } else {
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            }
        }
    });

    function formatNumberInput(query) {
        $(query).val(function (index, value) {
            return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        });

        $(query).on('keyup', function (event) {
            if (event.which >= 37 && event.which <= 40) return;
            $(this).val(function (index, value) {
                return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            });
        });
    }

    formatNumberInput('#sale_max_price')
    formatNumberInput('#sale_min_price')
    formatNumberInput('#resale_max_price')
    formatNumberInput('#resale_min_price')

    $('#sale_search_submit').one('submit', function (e) {
        e.preventDefault();
        if ($('#sale_max_price').val() != '') {
            $('#sale_max_price').val(parseInt($('#sale_max_price').val().replace(/\,/g, '')))
        }

        if ($('#sale_min_price').val() != '') {
            $('#sale_min_price').val(parseInt($('#sale_min_price').val().replace(/\,/g, '')))
        }
        $(this).submit();
    });

    $('#resale_search_submit').one('submit', function (e) {
        e.preventDefault();
        if ($('#resale_max_price').val() != '') {
            $('#resale_max_price').val(parseInt($('#resale_max_price').val().replace(/\,/g, '')))
        }

        if ($('#resale_min_price').val() != '') {
            $('#resale_min_price').val(parseInt($('#resale_min_price').val().replace(/\,/g, '')))
        }
        $(this).submit();
    });

    if (screen.width > 992) {
        setTimeout(() => loadIntlTelInput(".bitrix24-web input[type='tel'].b24-form-control"), 6500);
    } else {
        setTimeout(() => loadIntlTelInput(".bitrix24-web input[type='tel'].b24-form-control"), 11500);
    }

    setTimeout(() => {
        $('.header-before-load').hide()
        $('.header-after-load').removeClass('header-after-load').show()
    }, 4000);
})

/**
 * Cached fetch with 24-hour expiration and optional stale data fallback
 * @param {string} url - The URL to fetch
 * @param {Object} [options] - Fetch options + cache control
 * @param {boolean} [options.allowStale=false] - Return expired cache if fetch fails
 * @param {number} [options.cacheDuration=86400000] - Cache duration in ms (default 24h)
 * @returns {Promise<Response>}
 */
async function cachedFetch(url, options = {}) {
    const {
        allowStale = false, cacheDuration = (24 * 60 * 60 * 1000) * 7, // 24 hours
        ...fetchOptions
    } = options;

    const cacheKey = `fetch-cache:${url}`;
    const now = Date.now();

    // Try to get cached data
    const cached = localStorage.getItem(cacheKey);
    let cachedData = null;

    if (cached) {
        try {
            cachedData = JSON.parse(cached);
        } catch (e) {
            console.warn('Failed to parse cache for', url);
            localStorage.removeItem(cacheKey);
        }
    }

    // Return cached data if not expired
    if (cachedData && now - cachedData.timestamp < cacheDuration) {
        return new Response(new Blob([JSON.stringify(cachedData.data)]), {
            headers: {'Content-Type': 'application/json'}
        });
    }

    try {
        // Fetch fresh data
        const response = await fetch(url, fetchOptions);
        const data = await response.json();

        // Cache the new data
        const cacheItem = {
            data, timestamp: now, headers: {'Content-Type': 'application/json'}
        };
        localStorage.setItem(cacheKey, JSON.stringify(cacheItem));

        return new Response(JSON.stringify(data), {
            headers: {'Content-Type': 'application/json'}
        });
    } catch (error) {
        // If fetch fails, return stale data if allowed and available
        if (allowStale && cachedData) {
            console.warn('Using stale cache for', url, error);
            return new Response(JSON.stringify(cachedData.data), {
                headers: {'Content-Type': 'application/json'}
            });
        }
        throw error;
    }
}

function loadIntlTelInput(selector) {
    cachedFetch("https://ipapi.co/json?key=zggTNJH3ukYDOsT8VVgWqYP0MdnIgDkCmj9CkwyKMpfzSviqpJ", {allowStale: true})
        .then(res => res.json())
        .then(data => {
            $(selector).val(data.country_calling_code)
            $(selector).intlTelInput({
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.1.6/js/utils.min.js",
                nationalMode: false,
                separateDialCode: false,
                initialCountry: "auto",
                geoIpLookup: callback => data.country_code ?? 'TR',
                preferredCountries: ["SA", "TR", "KW", "IQ", "QA", "BH", "SY", "EG", "OM",],
            })
        })
}
